import GoHome from './GoHome';
import GoBack from './GoBack';
import Ping from './Ping';
import StartProcessingCash from './StartProcessingCash';
import StopProcessingCash from './StopProcessingCash';
import ReturnCash from './ReturnCash';
import PrintReceipt from './PrintReceipt';
import EmailReceipt from './EmailReceipt';
import UserActivity from './UserActivity';
import HomeButtonHide from './HomeButtonHide';
import HomeButtonShow from './HomeButtonShow';
import ReceiptAttributes from './ReceiptAttributes';
import GetSession from './GetSession';
import StackCash from './StackCash';
import LogError from './LogError';
import GoPayment from './GoPayment';
import GetTheme from './GetTheme';
import FillStack from './FillStack';

export interface SdkMethodMap {
    [key: string]: any;
}

export const methods: SdkMethodMap = {
    GoBack: GoBack,
    GoHome: GoHome,
    Ping: Ping,

    StartProcessingCash: StartProcessingCash,
    ReturnCash: ReturnCash,
    StopProcessingCash: StopProcessingCash,

    PrintReceipt: PrintReceipt,
    EmailReceipt: EmailReceipt,
    UserActivity: UserActivity,
    HomeButtonHide: HomeButtonHide,
    HomeButtonShow: HomeButtonShow,
    ReceiptAttributes: ReceiptAttributes,
    GetSession,
    StackCash,
    LogError,
    GoPayment,
    GetTheme: GetTheme,
    FillStack: FillStack,
};
